module.exports = __webpack_public_path__ + "img/Logo.423cdb4f.svg";